/**
 * @file Renders the platform's powered-by logo image.
 */
import type { CSSProperties } from "react";
import { Image } from "antd";

import { getConfig } from "@components/Config";

import LOGO_POWERED_BY_PATH from "./powered-by.png";

const PLATFORM_NAME = getConfig<string>("PLATFORM_NAME");

type Props = {
  width?: string | number;
  style?: CSSProperties;
};

/**
 * Renders the platform's powered-by logo image.
 */
const PoweredByLogo = ({
  width = "100%",
  style = {},
}: Props): JSX.Element => {
  return (
    <Image
      alt={`Powered by ${PLATFORM_NAME}`}
      src={LOGO_POWERED_BY_PATH}
      width={width}
      style={style}
      preview={false}
    />
  );
};

export default PoweredByLogo;
